import { numberConvert } from "@website/utils/number-convert";
import { NumberSeparatorType } from "@website/utils/number-separator/number-separator.types";
import toString from "lodash-es/toString";
import trimStart from "lodash-es/trimStart";

export const numberSeparator: NumberSeparatorType = (text, options) => {
  const value = trimStart(toString(text), "0 ") || "0";
  return numberConvert(
    value.slice(0, value.includes(".") ? value.indexOf(".") : value.length),
    {
      numberOnly: true,
      locale: "en"
    }
  ).replaceAll(/\B(?=(\d{3})+(?!\d))/g, options?.separator || ",");
};
